<div
  #panel
  class="tw-fixed tw-inset-0 tw-z-[1500] tw-flex tw-flex-col tw-bg-white tw-transition-transform tw-duration-300 tw-ease-in-out lg:tw-hidden"
  [ngClass]="{
    'tw-translate-x-0': isPanelActive(),
    'ltr:tw-translate-x-full rtl:-tw-translate-x-full': !isPanelActive()
  }"
  [attr.aria-hidden]="!isPanelActive()"
>
  <header class="tw-flex tw-shrink-0 tw-items-center tw-px-4 tw-py-4">
    <button
      type="button"
      class="tw-flex tw-h-8 tw-w-8 tw-items-center tw-justify-center"
      [attr.aria-label]="'Back'"
      (click)="onClose()"
    >
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M13.8663 20C13.3517 19.9999 12.8582 19.7894 12.4944 19.4147L4.73223 11.4245C4.36843 11.0499 4.16406 10.542 4.16406 10.0123C4.16406 9.4826 4.36843 8.9746 4.73223 8.60001L12.4944 0.609827C12.6734 0.419041 12.8875 0.266864 13.1243 0.162174C13.361 0.0574851 13.6157 0.00238022 13.8733 7.54214e-05C14.131 -0.00222938 14.3865 0.0483115 14.625 0.14875C14.8635 0.249188 15.0802 0.397512 15.2624 0.585067C15.4446 0.772622 15.5887 0.995652 15.6862 1.24114C15.7838 1.48663 15.8329 1.74967 15.8307 2.0149C15.8284 2.28014 15.7749 2.54225 15.6732 2.78596C15.5715 3.02967 15.4236 3.25009 15.2383 3.43436L8.84811 10.0123L15.2383 16.5902C15.5096 16.8696 15.6944 17.2254 15.7692 17.6129C15.844 18.0003 15.8056 18.4019 15.6588 18.7668C15.5119 19.1318 15.2633 19.4437 14.9442 19.6632C14.6252 19.8827 14.2501 19.9999 13.8663 20Z" fill="#1C64F2"/>
      </svg>      
    </button>

    <h2 class="tw-flex-1 tw-text-center tw-font-inter tw-text-base tw-font-bold tw-text-gray-900 tw-pr-8">
      {{ title() }}
    </h2>
  </header>

  <div class="tw-flex-1 tw-overflow-y-auto tw-px-6">
    <ng-content />
  </div>

  <footer class="tw-relative tw-flex tw-shrink-0 tw-gap-3 tw-bg-white tw-px-6 tw-pt-4 tw-pb-[max(1rem,env(safe-area-inset-bottom))] tw-shadow-[0_-2px_2px_rgba(0,0,0,0.08)]">
    <button
      type="button"
      class="tw-flex tw-flex-1 tw-items-center tw-justify-center tw-gap-2 tw-rounded-lg tw-border tw-border-gray-200 tw-bg-white tw-py-2.5 tw-font-inter tw-text-sm tw-font-medium tw-text-gray-800"
      (click)="onReset()"
    >
      Clear
    </button>

    <button
      type="button"
      class="tw-bg-blue-600 tw-font-inter tw-text-sm tw-font-medium tw-text-white tw-rounded-lg tw-flex tw-flex-1 tw-items-center tw-justify-center tw-gap-2 tw-py-2.5"
      (click)="onApply()"
    >
      Apply
    </button>
  </footer>
</div>
